const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

// Page-level copy for /deals and the home page deals section.
// Like "homes", the latest enabled row is the one shown on the website.

const editable = (type, extra = {}) => ({
  type,
  validation: [],
  list: false,
  read: true,
  create: true,
  edit: true,
  ...extra,
});

const text = (name, extraUi = {}) => ({
  name,
  type: types.STRING,
  allowNull: true,
  validation: [validatorTypes.string, validatorTypes.optional],
  ui: editable(uiTypes.TEXT, extraUi),
});

const textArea = (name) => ({
  name,
  type: types.TEXT,
  allowNull: true,
  validation: [validatorTypes.string, validatorTypes.optional],
  ui: editable(uiTypes.TEXT_AREA),
});

const repeater = (name, fields) => ({
  name,
  type: types.JSON,
  isArray: true,
  allowNull: true,
  validation: [validatorTypes.array, validatorTypes.optional],
  ui: editable(uiTypes.DYNAMICJSON, { dynamicArrayfeilds: fields }),
});

const obj = {
  tableName: "deals_page",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false,
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },

    // Deals page hero
    text("hero_eyebrow", { list: true }),
    text("hero_title_start"),
    text("hero_title_highlight"),
    text("hero_title_end"),
    textArea("hero_description"),
    repeater("metrics", [
      { name: "label", type: "text" },
      { name: "value", type: "text" },
      { name: "unit", type: "text" },
      { name: "note", type: "text" },
    ]),

    // Deals section (deals page + home page)
    text("section_eyebrow"),
    text("section_title", { list: true }),
    textArea("section_description"),
    text("banner_title"),
    text("banner_text"),
    text("banner_button_text"),

    // FAQ section (deals page). Lower priority numbers are shown first.
    text("faq_title"),
    text("faq_subtitle"),
    repeater("faq", [
      { name: "question", type: "text" },
      { name: "answer", type: "textarea" },
      { name: "priority", type: "text" },
    ]),

    // SEO
    text("meta_title"),
    textArea("meta_description"),

    {
      name: "show_on_home",
      type: types.BOOLEAN,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: editable(uiTypes.SWITCH, { list: true }),
    },
    {
      name: "enabled",
      type: types.BOOLEAN,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: editable(uiTypes.SWITCH, { list: true }),
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: false,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
// The deals section was taken off the home page; keep the column but hide
// the switch in the admin since it no longer controls anything.
for (const column of obj.columns) {
  if (column.name === "show_on_home") {
    column.ui = { ...column.ui, list: false, read: false, create: false, edit: false };
  }
}

module.exports = obj;
